import type { TFunction } from "@/i18n/catalog";

/**
 * The EU 14 declarable allergens, stored on `inventory_items.allergens` as these exact strings.
 * The value is the wire identifier; only the label is translated (POS2-1134).
 *
 * This list was written out three times — `pages/inventory.tsx`, `settings/catalogue.tsx` and
 * `components/inventory-item-form.tsx` — each using the wire value as its own label, which is why
 * a German reader saw `celery` beside `Allergene (EU 14)`.
 */
export const EU_14_ALLERGENS = [
  "celery",
  "crustaceans",
  "eggs",
  "fish",
  "gluten",
  "lupin",
  "milk",
  "molluscs",
  "mustard",
  "nuts",
  "peanuts",
  "sesame",
  "soy",
  "sulphites",
] as const;

/**
 * Literal keys in a lookup table, never a key assembled at runtime — `check-i18n.mjs` resolves
 * keys statically, so a built key is invisible to it.
 */
const ALLERGEN_LABEL_KEYS: Record<string, string> = {
  celery: "reference.allergen.celery",
  crustaceans: "reference.allergen.crustaceans",
  eggs: "reference.allergen.eggs",
  fish: "reference.allergen.fish",
  gluten: "reference.allergen.gluten",
  lupin: "reference.allergen.lupin",
  milk: "reference.allergen.milk",
  molluscs: "reference.allergen.molluscs",
  mustard: "reference.allergen.mustard",
  nuts: "reference.allergen.nuts",
  peanuts: "reference.allergen.peanuts",
  sesame: "reference.allergen.sesame",
  soy: "reference.allergen.soy",
  sulphites: "reference.allergen.sulphites",
};

/** An allergen a row carries that is not one of the fourteen reads as stored. */
export function allergenLabel(t: TFunction, key: string): string {
  const labelKey = ALLERGEN_LABEL_KEYS[key];
  return labelKey ? t(labelKey) : key;
}
